module.exports = __webpack_public_path__ + "assets/img/18_1858.3f00ad6c.jpg";